"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmoteCategory = void 0;
const validation_1 = require("../validation");
var EmoteCategory;
(function (EmoteCategory) {
    EmoteCategory["SIMPLE"] = "simple";
    EmoteCategory["LOOP"] = "loop";
})(EmoteCategory = exports.EmoteCategory || (exports.EmoteCategory = {}));
(function (EmoteCategory) {
    EmoteCategory.schema = {
        type: 'string',
        enum: Object.values(EmoteCategory)
    };
    EmoteCategory.validate = (0, validation_1.generateValidator)(EmoteCategory.schema);
})(EmoteCategory = exports.EmoteCategory || (exports.EmoteCategory = {}));
//# sourceMappingURL=emote-category.js.map